import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "../i18n";

const PostForm = ({ selectedGame, postTitle, postText, tags, isPublic, setPostTitle, setPostText, setSelectedTags, setSelectedGame }) => {
  const [postMessage, setPostMessage] = useState("");
  const navigate = useNavigate();

  const submitHandler = (event) => {
    event.preventDefault();

    if (!postTitle.trim() || !postText.trim()) {
      setPostMessage(t("title_body_empty_error"));
      return;
    }
    
    const requestBody = {
      authorID: sessionStorage.getItem("user"),
      content: postText,          // Post body
      attributes: {
        title: postTitle,                     // Post Title
        tags: Array.isArray(tags) ? tags : [], // Array of Tags
        game: selectedGame || "",             // The Selected Game Tag
        visibility: isPublic ? "public" : "private"   // Store visibility under attributes
      },
    };

    // Testing
    console.log("Sending Post Request:", requestBody);

    fetch(`${process.env.REACT_APP_API_PATH}/posts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      body: JSON.stringify(requestBody),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("Post Created:", result);

        setPostTitle("");
        setPostText("");
        setSelectedTags([]);
        setSelectedGame("");
        navigate("/");   // Redirect to home
      })
      .catch((error) => {
        console.error("Error creating post:", error);
        setPostMessage(t("post_creation_error")); // Set postMessage state
      });
      
  };

  return (
    <div>
      <form onSubmit={submitHandler}>
        <button type="submit" className="post-button">{t("create")}</button>
        <br />
        {postMessage && <p className="error-message">{postMessage}</p>}
      </form>
    </div>
  );
};

export default PostForm;
